import { useCallback, useReducer, useState } from 'react';

import { useMountedState } from './use-mounted-state';

const useAsyncSafeState = (...args) => {
  const isMounted = useMountedState();
  const [value, setValue] = useState(...args);
  const asyncSafeSetValue = useCallback(
    (newValue) => {
      if (isMounted.current) {
        return setValue(newValue);
      }
      // oxlint-disable-next-line consistent-return
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- isMounted is a ref
    [],
  );

  return [value, asyncSafeSetValue];
};

const useAsyncSafeReducer = (...args) => {
  const isMounted = useMountedState();
  const [state, dispatch] = useReducer(...args);
  const asyncSafeDispatch = useCallback(
    (action) => {
      if (isMounted.current) {
        return dispatch(action);
      }
      // oxlint-disable-next-line consistent-return
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- isMounted is a ref
    [],
  );

  return [state, asyncSafeDispatch];
};

export { useAsyncSafeReducer, useAsyncSafeState };
